/* @flow */
export const BACKSPACE: number = 8;
export const DOWN: number = 40;
export const ENTER: number = 13;
export const LEFT: number = 37;
export const RIGHT: number = 39;
export const SPACE: number = 32;
export const TAB: number = 9;
export const UP: number = 38;



// WEBPACK FOOTER //
// ./src/constants/keycodes.js